import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation(); // Obtém o caminho atual da rota

  useEffect(() => {
    // Rola para o topo da janela ao mudar de rota
    window.scrollTo(0, 0);
  }, [pathname]); // O efeito será re-executado sempre que o pathname mudar

  return null; // Este componente não renderiza nada no DOM
}

export default ScrollToTop;